





































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop, Ref } from 'vue-property-decorator'
import { DirectiveBinding } from 'vue/types/options'

import CustomEditor from '../logic/Editor/CustomEditor'
import CustomNode from '../logic/Nodes/CustomNode'
import { getPickerHexColor } from '../utils/getPickerColor'
import InputSocket from './Socket/InputSocket.vue'
import OutputSocket from './Socket/OutputSocket.vue'

@Component({
  methods: {
    snakeCase,
  },
  data() {
    return {
      CustomNode,
      OutputSocket,
    }
  },
  components: {
    InputSocket,
  }
})
export default class NodeWrapper extends Vue {
  @Prop() node!: CustomNode

  @Prop() bindSocket!: DirectiveBinding

  @Prop() editor!: CustomEditor

  @Ref('body') body!: HTMLDivElement

  isHover = false

  get output() {
    if (this.node.mainOutput) {
      return Vue.observable(this.node.outputs.get(this.node.mainOutput))
    }

    return undefined
  }

  get input() {
    if (this.node.mainInput) {
      return Vue.observable(this.node.inputs.get(this.node.mainInput))
    }

    return undefined
  }

  get selected(): boolean {
    return this.editor.selected.contains(this.node)
  }

  get titleColor(): string {
    if (this.node.color) {
      const color = getPickerHexColor(this.node.color)

      if (color) {
        const { r, g, b } = color

        if (this.selected || this.isHover) {
          return `rgba(${ r }, ${ g }, ${ b }, 0.5)`
        }

        return `rgba(${ r }, ${ g }, ${ b }, 0.2)`
      }
    }

    return this.selected || this.isHover ? 'rgba(var(--a-primary), 0.5)' : 'rgba(var(--a-primary), 0.2)'
  }

  private observer: ResizeObserver | null = null

  mounted(): void {
    // eslint-disable-next-line compat/compat
    this.observer = new ResizeObserver(() => this.editor.view.updateConnections({ node: this.node }))

    this.observer.observe(this.body)
  }

  destroyed(): void {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
